<template>
  <div
    class="ts-tag"
    :class="{ clickable: hasClickHandler, rounded, primary, small: size === 'small' }"
    @click="handleClick"
  >
    <div class="inner">
      <p class="value"><slot></slot></p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ts-tag {
  box-shadow: inset -2px -2px 6px 0 #fafbff, inset 2px 2px 6px 0 #a6abbd;
  border-radius: 8px;

  display: inline-block;

  .inner {
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.4);
    box-shadow: inset -2px -2px 6px 0 #fafbff, inset 2px 2px 6px 0 #a6abbd;
    border-radius: 8px;

    display: inline-block;

    .value {
      font-family: Roboto;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 18px;
      letter-spacing: normal;
      color: #6d748a;

      margin: 0;
      padding: 7px 10px;
    }
  }

  &.clickable {
    cursor: pointer;
  }

  &.rounded {
    border-radius: 50px;

    .inner {
      border-radius: 50px;
    }
  }

  &.primary {
    .inner {
      background: #99ffd1;
      box-shadow: none;

      .value {
        color: #33373d;
      }
    }
  }

  &.small {
    .value {
      padding: 4px 8px;
    }
  }
}
</style>

<script>
export default {
  name: 'TsTag',
  props: {
    rounded: {
      type: Boolean,
      default: false
    },
    primary: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    hasClickHandler() {
      return !!this.$listeners.click;
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>
